
document.addEventListener('DOMContentLoaded',()=>{

if(window.gsap){
gsap.registerPlugin(ScrollTrigger);

gsap.from('.hero-title',{
y:80,
opacity:0,
duration:1.2,
ease:'power4.out'
});

gsap.from('.hero-copy',{
y:30,
opacity:0,
duration:.9,
delay:.25
});

if(document.querySelector('.airy2-hero')){
var airyTl=gsap.timeline({defaults:{ease:'power3.out'}});
airyTl.from('.airy2-kicker',{y:20,opacity:0,duration:.6})
.from('.airy2-title',{y:50,opacity:0,duration:.9},'-=.35')
.from('.airy2-tagline',{y:20,opacity:0,duration:.7},'-=.55')
.from('.airy2-hero-btn',{y:20,opacity:0,duration:.6},'-=.45')
.from('.airy2-hero-image img',{scale:.85,opacity:0,duration:1.1,ease:'power2.out'},'-=.9');
}

gsap.utils.toArray('.reveal-item').forEach((item)=>{
gsap.from(item,{
y:60,
opacity:0,
duration:1,
ease:'power3.out',
scrollTrigger:{
trigger:item,
start:'top 88%'
}
});
});
}

var transparentHeader=document.querySelector('.lux-header-transparent');
if(transparentHeader){
var toggleHeaderScrolled=function(){
transparentHeader.classList.toggle('scrolled',window.scrollY>80);
};
toggleHeaderScrolled();
window.addEventListener('scroll',toggleHeaderScrolled,{passive:true});
}

var productForm=document.getElementById('product-form');
var sizeRow=document.getElementById('sizeRow');
if(productForm && sizeRow){
productForm.addEventListener('submit',function(e){
e.preventDefault();
var checked=sizeRow.querySelector('.size-radio:checked');
if(!checked){
sizeRow.classList.add('error');
var sizeError=document.getElementById('sizeError');
if(sizeError){sizeError.classList.add('show');}
sizeRow.scrollIntoView({behavior:'smooth',block:'center'});
setTimeout(function(){sizeRow.classList.remove('error');},400);
return;
}
addToCartAjax(productForm);
});
sizeRow.addEventListener('change',function(){
sizeRow.classList.remove('error');
var sizeError=document.getElementById('sizeError');
if(sizeError){
sizeError.textContent='Please select a size.';
sizeError.classList.remove('show');
}
});
sizeRow.addEventListener('click',function(e){
var pill=e.target.closest('.size-pill.sold-out');
if(!pill){return;}
var sizeError=document.getElementById('sizeError');
if(sizeError){
sizeError.textContent='This size is out of stock.';
sizeError.classList.add('show');
}
});
}

document.addEventListener('submit',function(e){
var form=e.target;
if(form.classList && form.classList.contains('quick-add-form')){
e.preventDefault();
handleQuickAdd(form);
}
});

bindCartDrawerEvents();
markWishlistIcons();
updateWishlistCount();

document.querySelectorAll('.product-card').forEach(function(card){
var video=card.querySelector('.product-hover-video');
if(!video){return;}
card.addEventListener('mouseenter',function(){
var playPromise=video.play();
if(playPromise!==undefined){playPromise.catch(function(){});}
});
card.addEventListener('mouseleave',function(){
video.pause();
video.currentTime=0;
});
});

var stickyCart=document.querySelector('.mobile-sticky-cart');
var footer=document.querySelector('.lux-footer');
if(stickyCart && footer && window.IntersectionObserver){
var footerObserver=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
stickyCart.classList.toggle('hide',entry.isIntersecting);
});
},{root:null,threshold:0});
footerObserver.observe(footer);
}

var autoplayVideos=document.querySelectorAll('.airy2-fabric-video, .made-right-video, .about-film-video');
if(autoplayVideos.length && window.IntersectionObserver){
var videoObserver=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
var v=entry.target;
if(entry.isIntersecting){
var playPromise=v.play();
if(playPromise!==undefined){
playPromise.catch(function(){});
}
}else{
v.pause();
}
});
},{threshold:.25});
autoplayVideos.forEach(function(v){
v.muted=true;
videoObserver.observe(v);
});
}

var heroSlidesTrack=document.getElementById('heroSlides');
if(heroSlidesTrack){
var heroSlides=heroSlidesTrack.querySelectorAll('.hero-slide');
var heroDots=document.querySelectorAll('#heroDots .hero-dot');
var heroSpeed=(parseFloat(heroSlidesTrack.dataset.speed)||5)*1000;
var heroIdx=0;
if(heroSlides.length>1){
setInterval(function(){
heroSlides[heroIdx].classList.remove('active');
if(heroDots[heroIdx]){heroDots[heroIdx].classList.remove('active');}
heroIdx=(heroIdx+1)%heroSlides.length;
heroSlides[heroIdx].classList.add('active');
if(heroDots[heroIdx]){heroDots[heroIdx].classList.add('active');}
},heroSpeed);
}
}

var bar=document.getElementById('announcementBar');
if(bar){
var spans=bar.querySelectorAll('span');
var idx=0;
if(spans.length>1){
setInterval(function(){
spans[idx].classList.remove('active');
idx=(idx+1)%spans.length;
spans[idx].classList.add('active');
},3200);
}
}

});

function openFilterPanel(){
var panel=document.getElementById('filterPanel');
var overlay=document.getElementById('filterOverlay');
if(panel){panel.classList.add('open');}
if(overlay){overlay.classList.add('open');}
}

function closeFilterPanel(){
var panel=document.getElementById('filterPanel');
var overlay=document.getElementById('filterOverlay');
if(panel){panel.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
}

function openMobileNav(){
var panel=document.getElementById('mobileNavPanel');
var overlay=document.getElementById('mobileNavOverlay');
if(panel){panel.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
}

function openSizeGuide(){
var overlay=document.getElementById('sizeGuideOverlay');
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
}

function closeSizeGuide(){
var overlay=document.getElementById('sizeGuideOverlay');
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function switchSizeUnit(btn,unit){
document.querySelectorAll('.size-guide-unit-btn').forEach(function(b){b.classList.remove('active');});
btn.classList.add('active');
document.querySelectorAll('.size-guide-table td[data-in]').forEach(function(td){
td.textContent = unit==='cm' ? td.dataset.cm : td.dataset.in;
});
}

function closeMobileNav(){
var panel=document.getElementById('mobileNavPanel');
var overlay=document.getElementById('mobileNavOverlay');
if(panel){panel.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function openCartDrawer(){
var drawer=document.getElementById('cartDrawer');
var overlay=document.getElementById('cartDrawerOverlay');
if(drawer){drawer.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
loadCartUpsell();
}

function closeCartDrawer(){
var drawer=document.getElementById('cartDrawer');
var overlay=document.getElementById('cartDrawerOverlay');
if(drawer){drawer.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function bindCartDrawerEvents(){
var drawer=document.getElementById('cartDrawer');
if(!drawer){return;}
drawer.querySelectorAll('.cart-drawer-qty-select').forEach(function(sel){
sel.addEventListener('change',function(){
var quantity=parseInt(sel.value,10);
if(quantity===0){
var itemEl=sel.closest('.cart-drawer-item');
if(itemEl){itemEl.remove();}
}
changeCartItem(sel.dataset.key,quantity);
});
});
}

function getFormButtons(form){
var buttons=Array.from(form.querySelectorAll('button[type="submit"]'));
if(form.id){
buttons=buttons.concat(Array.from(document.querySelectorAll('button[form="'+form.id+'"]')));
}
return buttons;
}

function animateAddButton(button){
if(!button){return;}
if(!button.querySelector('.btn-label-wrap')){
var originalText=button.textContent.trim();
button.innerHTML=
'<span class="btn-label-wrap">'+
'<span class="btn-label btn-label-default">'+originalText+'</span>'+
'<span class="btn-label btn-label-success"><svg class="btn-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Added to Cart</span>'+
'</span>';
}
button.classList.add('added');
button.disabled=true;
}

function resetAddButton(button){
if(!button){return;}
button.classList.remove('added');
button.disabled=false;
}

function addToCartAjax(form){
var buttons=getFormButtons(form);
buttons.forEach(animateAddButton);
var formData=new FormData(form);
var addPromise=fetch('/cart/add.js',{method:'POST',body:formData,headers:{'Accept':'application/json'}})
.then(function(res){
if(!res.ok){throw new Error('add failed');}
return res.json();
});
var minDelay=new Promise(function(resolve){setTimeout(resolve,650);});
Promise.all([addPromise,minDelay])
.then(function(){
refreshCartDrawer();
openCartDrawer();
setTimeout(function(){buttons.forEach(resetAddButton);},400);
})
.catch(function(){
buttons.forEach(resetAddButton);
form.submit();
});
}

function changeCartItem(key,quantity){
fetch('/cart/change.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({id:key,quantity:quantity})
})
.then(function(){return refreshCartDrawer();});
}

function refreshCartDrawer(){
return fetch(window.location.pathname+'?sections=cart-drawer')
.then(function(res){return res.json();})
.then(function(data){
var html=data['cart-drawer'];
if(!html){return;}
var temp=document.createElement('div');
temp.innerHTML=html;
var newDrawer=temp.querySelector('#cartDrawer');
var oldDrawer=document.getElementById('cartDrawer');
if(newDrawer && oldDrawer){
oldDrawer.innerHTML=newDrawer.innerHTML;
bindCartDrawerEvents();
}
})
.then(function(){return fetch('/cart.js');})
.then(function(res){return res.json();})
.then(function(cart){
document.querySelectorAll('.cart-count:not(.wishlist-count)').forEach(function(el){
el.textContent=cart.item_count;
el.style.display = cart.item_count > 0 ? '' : 'none';
});
loadCartUpsell();
});
}

var upsellVariantsMap={};

function normalizeVariants(rawVariants){
return (rawVariants||[]).map(function(v){
return {id:v.id, title:v.title, available: v.available!==false};
});
}

function normalizeRecommendation(p){
return {
id:String(p.id),
title:p.title,
url:p.url || ('/products/'+p.handle),
image:(p.images && p.images[0]) || '',
price:(typeof p.price==='number') ? p.price/100 : 0,
variants: normalizeVariants(p.variants)
};
}

function normalizeCatalogProduct(p){
var variant=(p.variants && p.variants[0]) || {};
var img=(p.images && p.images[0] && p.images[0].src) || '';
return {
id:String(p.id),
title:p.title,
url:'/products/'+p.handle,
image:img,
price: variant.price ? parseFloat(variant.price) : 0,
variants: normalizeVariants(p.variants)
};
}

function renderUpsell(products){
var grid=document.getElementById('cartDrawerUpsellGrid');
if(!grid || !products.length){return;}
upsellVariantsMap={};
grid.innerHTML=products.map(function(p){
upsellVariantsMap[p.id]=p.variants||[];
var price=p.price.toLocaleString('en-IN',{style:'currency',currency:'INR',minimumFractionDigits:0});
return '<div class="cart-drawer-upsell-card">'+
'<a href="'+p.url+'" class="cart-drawer-upsell-link">'+
'<div class="cart-drawer-upsell-image"><img src="'+p.image+'" alt="'+(p.title||'').replace(/"/g,'&quot;')+'" loading="lazy"></div>'+
'<p class="cart-drawer-upsell-name">'+p.title+'</p>'+
'<p class="cart-drawer-upsell-price">'+price+'</p>'+
'</a>'+
'<div class="cart-drawer-upsell-action" data-product-id="'+p.id+'">'+
'<button type="button" class="cart-drawer-upsell-add-btn">+ Add</button>'+
'</div>'+
'</div>';
}).join('');
bindUpsellAddButtons();
}

function bindUpsellAddButtons(){
var grid=document.getElementById('cartDrawerUpsellGrid');
if(!grid){return;}
grid.querySelectorAll('.cart-drawer-upsell-add-btn').forEach(function(btn){
btn.addEventListener('click',function(){
var actionEl=btn.closest('.cart-drawer-upsell-action');
var pid=actionEl.dataset.productId;
var variants=upsellVariantsMap[pid]||[];
var available=variants.filter(function(v){return v.available;});
if(variants.length<=1){
var only=available[0]||variants[0];
if(only){addUpsellVariant(only.id, actionEl);}
return;
}
showUpsellSizePicker(actionEl, available.length?available:variants);
});
});
}

function showUpsellSizePicker(actionEl, variants){
var select=document.createElement('select');
select.className='cart-drawer-upsell-size-select';
var placeholder=document.createElement('option');
placeholder.textContent='Size';
placeholder.value='';
select.appendChild(placeholder);
variants.forEach(function(v){
var opt=document.createElement('option');
opt.value=v.id;
opt.textContent=v.title;
select.appendChild(opt);
});
actionEl.innerHTML='';
actionEl.appendChild(select);
select.addEventListener('change',function(){
if(select.value){addUpsellVariant(select.value, actionEl);}
});
}

function addUpsellVariant(variantId, actionEl){
actionEl.innerHTML='<span class="cart-drawer-upsell-adding">Adding…</span>';
fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:[{id:variantId, quantity:1}]})
})
.then(function(res){
if(!res.ok){throw new Error('add failed');}
return res.json();
})
.then(function(){return refreshCartDrawer();})
.catch(function(){
actionEl.innerHTML='<button type="button" class="cart-drawer-upsell-add-btn">+ Add</button>';
bindUpsellAddButtons();
});
}

function loadCartUpsell(){
var el=document.getElementById('cartDrawerUpsell');
if(!el){return;}
var cartIds=Array.from(new Set((el.dataset.productIds||'').split(',').filter(Boolean)));
if(!cartIds.length){return;}

var recRequests=cartIds.slice(0,3).map(function(pid){
return fetch('/recommendations/products.json?product_id='+pid+'&limit=6&intent=complementary')
.then(function(res){return res.ok ? res.json() : {products:[]};})
.catch(function(){return {products:[]};});
});

Promise.all(recRequests).then(function(results){
var seen={};
var merged=[];
results.forEach(function(data){
(data.products||[]).forEach(function(raw){
var p=normalizeRecommendation(raw);
if(!seen[p.id] && cartIds.indexOf(p.id)===-1){
seen[p.id]=true;
merged.push(p);
}
});
});

if(merged.length>=6){
renderUpsell(merged.slice(0,6));
return;
}

fetch('/products.json?limit=100')
.then(function(res){return res.json();})
.then(function(data){
var pool=(data.products||[])
.map(normalizeCatalogProduct)
.filter(function(p){return cartIds.indexOf(p.id)===-1 && !seen[p.id];});
for(var i=pool.length-1;i>0;i--){
var j=Math.floor(Math.random()*(i+1));
var tmp=pool[i];pool[i]=pool[j];pool[j]=tmp;
}
var needed=6-merged.length;
renderUpsell(merged.concat(pool.slice(0,needed)));
})
.catch(function(){renderUpsell(merged);});
});
}

function getWishlist(){
try{ return JSON.parse(localStorage.getItem('braclo_wishlist') || '[]'); }
catch(e){ return []; }
}

function saveWishlist(list){
localStorage.setItem('braclo_wishlist', JSON.stringify(list));
updateWishlistCount();
}

function toggleWishlist(btn){
var id=btn.dataset.wishlistId;
var list=getWishlist();
var idx=list.findIndex(function(item){ return item.id===id; });
if(idx>-1){
list.splice(idx,1);
btn.classList.remove('active');
}else{
list.push({
id:id,
title:btn.dataset.wishlistTitle,
url:btn.dataset.wishlistUrl,
image:btn.dataset.wishlistImage,
price:btn.dataset.wishlistPrice
});
btn.classList.add('active');
}
saveWishlist(list);
renderWishlistDrawer();
}

function markWishlistIcons(){
var ids=getWishlist().map(function(item){ return item.id; });
document.querySelectorAll('.wishlist-heart').forEach(function(btn){
if(ids.indexOf(btn.dataset.wishlistId)>-1){ btn.classList.add('active'); }
});
}

function updateWishlistCount(){
var count=getWishlist().length;
document.querySelectorAll('.wishlist-count').forEach(function(el){
el.textContent=count;
if(el.classList.contains('cart-count')){
el.style.display = count > 0 ? '' : 'none';
}
});
}

function openWishlistDrawer(){
var drawer=document.getElementById('wishlistDrawer');
var overlay=document.getElementById('wishlistDrawerOverlay');
if(drawer){drawer.classList.add('open');}
if(overlay){overlay.classList.add('open');}
document.body.style.overflow='hidden';
renderWishlistDrawer();
}

function closeWishlistDrawer(){
var drawer=document.getElementById('wishlistDrawer');
var overlay=document.getElementById('wishlistDrawerOverlay');
if(drawer){drawer.classList.remove('open');}
if(overlay){overlay.classList.remove('open');}
document.body.style.overflow='';
}

function removeFromWishlist(id){
var list=getWishlist().filter(function(item){ return item.id!==id; });
saveWishlist(list);
document.querySelectorAll('.wishlist-heart[data-wishlist-id="'+id+'"]').forEach(function(btn){ btn.classList.remove('active'); });
renderWishlistDrawer();
}

function renderWishlistDrawer(){
var grid=document.getElementById('wishlistDrawerGrid');
var empty=document.getElementById('wishlistDrawerEmpty');
if(!grid){return;}
var list=getWishlist();
if(list.length===0){
grid.innerHTML='';
if(empty){empty.style.display='block';}
return;
}
if(empty){empty.style.display='none';}
grid.innerHTML=list.map(function(item){
return '<div class="wishlist-drawer-item">'+
'<a href="'+item.url+'" class="wishlist-drawer-item-image"><img src="'+item.image+'" alt="'+(item.title||'').replace(/"/g,'&quot;')+'" loading="lazy"></a>'+
'<div class="wishlist-drawer-item-info">'+
'<h4><a href="'+item.url+'">'+item.title+'</a></h4>'+
'<p class="wishlist-drawer-item-price">'+item.price+'</p>'+
'</div>'+
'<button type="button" class="wishlist-drawer-remove" onclick="removeFromWishlist(\''+item.id+'\')" aria-label="Remove">&times;</button>'+
'</div>';
}).join('');
}

function handleQuickAdd(form){
if(form.dataset.sizeMode==='1'){return;}
var variants=[];
try{ variants=JSON.parse(form.dataset.variants||'[]'); }catch(e){ variants=[]; }
var realSizes=variants.filter(function(v){return v.title && v.title!=='Default Title';});
if(variants.length>1 && realSizes.length>0){
showQuickAddSizePicker(form,variants);
return;
}
addToCartAjax(form);
}

function showQuickAddSizePicker(form,variants){
var btn=form.querySelector('.quick-add-btn');
if(!btn){return;}
form.dataset.sizeMode='1';
var select=document.createElement('select');
select.className='quick-add-size-select';
var placeholder=document.createElement('option');
placeholder.textContent='SELECT SIZE';
placeholder.value='';
select.appendChild(placeholder);
variants.forEach(function(v){
var opt=document.createElement('option');
opt.value=v.id;
opt.textContent=v.available? v.title : v.title+' (Sold out)';
opt.disabled=!v.available;
select.appendChild(opt);
});
btn.replaceWith(select);
select.addEventListener('change',function(){
if(!select.value){return;}
var hiddenInput=form.querySelector('input[name="id"]');
if(hiddenInput){hiddenInput.value=select.value;}
addToCartAjax(form);
});
}
